<div class="ttmodal" style="width:400px">
  <div class="ttmodal__header">
      <span class="ttmodal__title" *ngIf="isFECR==false">Equipment to Inspect</span>
      <span class="ttmodal__title" *ngIf="isFECR==true">Implement to Inspect</span>
       <a class="button waves-effect" (click)="onNoClick()">
        <i class="material-icons button__icon">cancel</i>
        <span class="button__text">Close</span>
      </a>
  </div>
  <div class="ttmodal__body" >
    <div class="search-options-cell" >
      <div class="input-container">
          <span class="label">Customer</span>
          <mat-form-field class="header-form-full-width" style="width: 100%;">
          <mat-select id="select-customer" placeholder="Select Customer" [(ngModel)]="selectedCustomer"
              (selectionChange)="loadJobsitesForCustomer()" ngDefaultControl required >
              <mat-option [value]="customer.Id" *ngFor="let customer of customerList">
                  {{customer.Name}}
              </mat-option>
          </mat-select>
          </mat-form-field>

      </div>
      <div class="input-container">
          <span class="label">Job Site</span>
          <mat-form-field class="header-form-full-width" style="width: 100%;">
          <mat-select id="select-jobsite" placeholder="Select Job Site" [(ngModel)]="selectedJobsite"
              (selectionChange)="loadEquipmentForJobsite()" ngDefaultControl required >
              <mat-option [value]="jobsite.Id" *ngFor="let jobsite of jobsiteList">
                  {{jobsite.Name}}
              </mat-option>
          </mat-select>
          </mat-form-field>
      </div>
      <div class="input-container" *ngIf="isFECR==false">
          <span class="label">Machine</span>
          <mat-form-field class="header-form-full-width" style="width: 100%;">
          <mat-select id="select-equipment-serialno" placeholder="Select Machine"
              [(ngModel)]="selectedEquipment" ngDefaultControl required  >
              <mat-option [value]="equipment.Id" *ngFor="let equipment of equipmentList">
                  {{equipment.SerialNumber}} ||  {{equipment.UnitNumber}}
              </mat-option>
          </mat-select>
          </mat-form-field>
      </div>
      <!-- TT-10488 -->
      <div class="input-container" *ngIf="isFECR == false && isStartBySupervisor && isSupervisour"> 
        <span class="label">To be Inspected By</span>
        <mat-form-field class="header-form-full-width" style="width: 100%;">
            <mat-select placeholder="To be Inspected By" [(ngModel)]="selectedInspectors" multiple ngDefaultControl (selectionChange)="onInspectorsChange($event)">
              <mat-option *ngFor="let inspector of inspectors" [value]="inspector.Id">
                {{inspector.Name | aesDecrypt}}
              </mat-option>
            </mat-select>
        </mat-form-field>
      </div>
      <div class="input-container" *ngIf="isFECR==true">
        <span class="label">Implement</span>
        <mat-form-field class="header-form-full-width" style="width: 100%;">
        <mat-select id="select-equipment-implement" placeholder="Select Implement"
            [(ngModel)]="selectedImplement" ngDefaultControl required  >
            <mat-option [value]="implement.Id" *ngFor="let implement of implementList">
                {{implement.Name}} 
            </mat-option>
        </mat-select>
        </mat-form-field>
    </div>
    <div class="input-container" *ngIf="isFECR==false">
        <span class="label">Inspection Date</span>
        <mat-form-field class="header-form-full-width" style="width: 100%;">
            <input matInput [matDatepicker]="pickerStart" [(ngModel)]="inspectionDate" required>
            <mat-placeholder>Inspection Date</mat-placeholder>
            <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
            <mat-datepicker #pickerStart></mat-datepicker>
          </mat-form-field>
    </div>
     
  </div>
  </div>

  <div class="ttmodal__footer" >
      <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
      <button mat-raised-button color="warn" [disabled]="disable" (click)="FillForm()">
          <i class="material-icons button__icon">save</i><span class="button__text">
            Start
          </span>
        </button>
      <!-- <button class="button button--primary" (click)="FillForm()" [disabled]="disable">Start</button> -->
      <!-- <a class="button button--primary" (click)="onCopyForm()" [disabled]="disable"><span class="button__text">Copy Form</span></a> -->
  </div>
</div>